import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { useLocation } from 'react-router-dom';

import { withMediaQueries } from 'hoc/withMediaQueries';

import { LanguageSelection, ProfilePic } from 'ui/atoms';

import { RoleImages } from 'utils/roles';

// eslint-disable-next-line import/no-cycle
import { Menu } from '../index';
import { HeaderContainer, PageContainer, PageContent } from './styles';
import i18next from 'i18next';

const GlobalLayout = ({ children, role }) => {
  const [vW, setVw] = useState(`${window.innerWidth * 0.01}px`);
  const location = useLocation();
  useEffect(() => {
    window.addEventListener('resize', () => {
      const newVw = `${window.innerHeight * 0.01}px`;
      setVw(newVw);
    });
    return () => {
      window.addEventListener('resize', () => null);
    };
  }, []);

  const changeLanguage = lang => {
    i18next.changeLanguage(lang);
  };

  return (
    <>
      <Menu />
      <PageContainer vh={vW} rotated={location?.pathname !== '/'}>
        <PageContent
          className="page-content"
          isOnDashboard={location.pathname === '/'}
        >
          <HeaderContainer>
            <ProfilePic src={RoleImages[role] || ''} />
            <LanguageSelection changeLanguageFallback={changeLanguage} />
          </HeaderContainer>
          {children}
        </PageContent>
      </PageContainer>
    </>
  );
};

GlobalLayout.propTypes = {
  children: PropTypes.node,
  role: PropTypes.string
};

export default withMediaQueries(GlobalLayout);
